import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import store from './store/index';
import { Provider } from 'react-redux';
import { Theme } from 'styles/Theme';
import { Preloader } from 'components/app/Preloader';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element was not found');
}

createRoot(rootElement).render(
  <BrowserRouter>
    <Provider store={store}>
      <Theme>
        <Preloader />
      </Theme>
    </Provider>
  </BrowserRouter>,
);

try {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (typeof window !== 'undefined') window.__plannerInitialized = false;
  // eslint-disable-next-line no-empty
} catch {}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
if (window && window['Cypress']) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window['store'] = store;
}
